import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import download from "downloadjs";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn,
	Card,
	CardTitle,
	CardMedia,
	CardText,
	FloatingActionButton
} from "material-ui";
import SearchIcon from "material-ui/svg-icons/action/search";
import {
	actionChangeDeclaracionJuradaProps,
	actionGetDeclaracionJuradasList,
	actionUpdateDeclaracionJurada
} from "../../actions/DeclaracionJuradaActions";
import {
	actionGenerateExcel,
	actionGenerateExcelById
} from "../../actions/GenerateExcelActions";
import {
	actionGetEmpresaByCuit,
	actionChangeEmpresaProps
} from "../../actions/EmpresaActions";
import {
	DECLARACION_JURADAS_NEW,
	DECLARACION_JURADAS_SHOW
} from "../../config/RoutesConstants";
import { MODE_CRU_CREATE, MODE_CRU_SHOW } from "../../actions/ActionConstants";
import Util, { SUCCESS, ERROR, WARNING } from "../../common/Util";
import OptionsTableRowColumn from "../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import {
	FlatButton,
	MenuItem,
	SelectField,
	RaisedButton,
	TextField,
	RadioButtonGroup,
	RadioButton
} from "material-ui";
import FilterCard from "../../components/FilterCard/FilterCard";
import DateRange from "../../components/DateRange/DateRange";
import { actionDownloadFile } from "../../actions/BoletaActions";
import {
	ROL_ADMIN,
	ROL_EMPRESA,
	ESTADO_DDJJ_ANULADA,
	ESTADO_DDJJ_ACTIVA,
	MESES,
	ROL_OPERADOR_AFFI,
	ESTADO_TICKET_VENCIDO,
	ESTADO_TICKET_ANULADO,
	ESTADO_TICKET_PAGADO,
	ESTADO_TICKET_PENDIENTE_PAGO,
	ESTADO_TICKET_PAGO_PARCIAL,
	ROL_SUB_ADMIN,
	ROL_OPERADOR_RECAUDA
} from "../../common/Constants";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import Paginator from "../../components/Paginator/Paginator";
import { MaskedTextField } from "vault-react-components";

let limitePagina = 10;

class DeclaracionJuradasIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			comentarioDelete: "",
			anios: this.getAnios(),
			comentarioDeleteRequerido: "",
			searchFieldValue: "",
			showFilterCard: false,
			login: this.props.login,
			rol: this.props.rol,
			declaracionJuradasList: !_.isEmpty(this.props.declaracionJuradasList)
				? this.props.declaracionJuradasList.splice(
						0,
						this.props.declaracionJuradasList.length
					)
				: [],
			date_from: new Date(),
			date_to: new Date(),
			disabledPeriodFilter: true,
			errors: {
				date_to: "",
				date_from: ""
			},
			status: "",
			cuit: "",
			cuitRequerido: "",
			disabledCompanyFilter: true,
			all: true,
			period: false,
			company: false
		};
		this.handleSearch = this.handleSearch.bind(this);
		this.onDownloadDDJJ = this.onDownloadDDJJ.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.onCreateOrUpdate = this.onCreateOrUpdate.bind(this);
		this.onTapConfirmDelete = this.onTapConfirmDelete.bind(this);
		this.getDeclaracionJuradas = this.getDeclaracionJuradas.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
		this.onChangeSearch = this.onChangeSearch.bind(this);
		this.handleKeyPressSearchInput = this.handleKeyPressSearchInput.bind(this);
		this.CleanFilters = this.CleanFilters.bind(this);
		this.toggledFilterButton = this.toggledFilterButton.bind(this);
		this.returnDownload = this.returnDownload.bind(this);
		this.generateExcelFilterShow = this.generateExcelFilterShow.bind(this);
		this.onChangeDateField = this.onChangeDateField.bind(this);
		this.onChangeRadioButtonGroup = this.onChangeRadioButtonGroup.bind(this);
	}

	componentWillMount() {
		if (this.props.rol === ROL_EMPRESA) {
			this.getDeclaracionJuradas(this.props.page, limitePagina);
		}
	}
	getDeclaracionJuradas(page, limit, activeFilters) {
		let { mes, anio, searchtext, status, rol } = this.props;
		if (rol === ROL_EMPRESA) {
			searchtext = null;
		}
		if (rol === ROL_ADMIN || rol === ROL_SUB_ADMIN || rol === ROL_EMPRESA) {
			this.props.actionGetDeclaracionJuradasList(
				searchtext,
				mes,
				anio,
				page,
				limit,
				status
			);
		} else if (
			(searchtext === "" || searchtext === " " || _.isEmpty(searchtext)) &&
			!mes &&
			!anio &&
			!status
		)
			Util.showNoty(WARNING, "Ingrese algún criterio de búsqueda.");
		else {
			this.props.actionGetDeclaracionJuradasList(
				searchtext,
				mes,
				anio,
				page,
				limit,
				status
			);
		}
	}
	getAnios() {
		let anios = [];
		let anioActual = moment().year();
		for (let i = anioActual; i >= 2013; i--)
			anios.push(<MenuItem value={i} key={i} primaryText={i} />);
		return anios;
	}

	renderPaginator = () => {
		return (
			<Paginator
				page={this.props.page}
				pageLimit={limitePagina}
				total={this.props.total}
				onChangePage={this.onChangePage}
			/>
		);
	};

	onChangeSearch({ target: { value } }) {
		this.props.actionChangeDeclaracionJuradaProps({ searchtext: value });
	}

	handleKeyPressSearchInput(e) {
		if (e.key === "Enter") {
			this.handleSearch();
		}
	}

	handleSearch() {
		this.props.actionChangeDeclaracionJuradaProps({
			page: 1
		});
		this.getDeclaracionJuradas(1, limitePagina);
	}

	CleanFilters() {
		this.props.actionChangeDeclaracionJuradaProps({
			mes: null,
			anio: null,
			status: null,
			activeFilters: false,
			declaracionJuradasList: [],
			searchtext: ""
		});
		this.setState({
			showFilterCard: false
		});
	}

	onCreateOrUpdate(declaracionJurada) {
		this.props.actionChangeDeclaracionJuradaProps({
			declaracionJurada: null,
			modeCRU: MODE_CRU_CREATE,
			djDetail: []
		});
		this.props.history.push(DECLARACION_JURADAS_NEW);
	}

	handleDelete(declaracionJurada) {
		this.refs["deleteConfirm"].open({
			title: "Anular Declaración Jurada",
			onAccept: this.onTapConfirmDelete.bind(this, declaracionJurada),
			requiredValidation: true
		});
	}

	handleShow(declaracionJurada) {
		this.props.actionChangeDeclaracionJuradaProps({
			modeCRU: MODE_CRU_SHOW,
			djDetail: [],
			declaracionJurada: declaracionJurada
		});
		this.props.history.push(DECLARACION_JURADAS_SHOW);
	}

	onTapConfirmDelete(declaracionJurada) {
		if (_.trim(this.state.comentarioDelete)) {
			this.props.actionUpdateDeclaracionJurada(
				{
					...declaracionJurada,
					notes: this.state.comentarioDelete,
					status: ESTADO_DDJJ_ANULADA
				},
				this.callbackUpdateDJStatus
			);
			this.setState({
				comentarioDelete: ""
			});
			return true;
		} else {
			this.setState({
				comentarioDeleteRequerido: "El campo comentario es requerido"
			});
			return false;
		}
	}

	returnConfirmDelete(response) {
		if (response === SUCCESS) {
			this.getDeclaracionJuradas(this.props.page, limitePagina);
			Util.showNoty(response, "La Declaración Jurada Anulada");
		} else if (response === ERROR) {
			Util.showNoty(response, "Error al Anular Declaración Jurada");
		} else {
			Util.showNoty(
				response,
				"No se puede Anular Declaración Jurada, tiene elementos asociados"
			);
		}
	}

	renderBlank() {
		let mensaje = "";
		if (this.props.busquedaRealizada) {
			mensaje = "No se encontraron resultados";
		} else {
			mensaje = "Aplique un criterio de búsqueda para visualizar datos";
		}
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>{mensaje}</p>
				</TableRowColumn>
			</TableRow>
		);
	}

	onChangePage(page) {
		this.props.actionChangeDeclaracionJuradaProps({
			page: page
		});
		this.getDeclaracionJuradas(page, limitePagina);
	}

	callbackUpdateDJStatus = response => {
		if (response === SUCCESS) {
			this.getDeclaracionJuradas(this.props.page, limitePagina);
			Util.showNoty(SUCCESS, "Declaracion jurada anulada exitosamente");
		} else if (response === ERROR) {
			Util.showNoty(ERROR, "Error al modificar Declaración Jurada");
		}
	};

	onDownloadDDJJ() {
		this.downloadFile("FORMATO IMPORTACION DDJJ.xlsx");
	}

	downloadFile(fileName) {
		this.props.actionDownloadFile(
			fileName,
			this.returnDownloadExample.bind(this)
		);
	}

	returnDownloadExample(blob) {
		download(blob, "FORMATO IMPORTACION DDJJ");
	}

	returnDownload(type, blob) {
		let fechaActual = moment().format("DD-MM-YYYY");
		let nombreArchivo = "";
		if (type === "ddjjCompany") {
			nombreArchivo =
				"DDJJCompany " + this.props.empresa.name + " - " + fechaActual;
			this.props.actionChangeEmpresaProps({
				empresa: null
			});
		} else if (type === "ddjjConcepts")
			nombreArchivo = "DDJJConcepts - " + fechaActual;
		else nombreArchivo = "DDJJ - " + fechaActual;
		download(blob, nombreArchivo);
	}

	onChangeComentario = ({ target: { value } }) => {
		let error = this.state.comentarioDeleteRequerido;
		if (_.trim(value)) {
			error = "";
		}
		this.setState({
			comentarioDelete: value,
			comentarioDeleteRequerido: error
		});
	};
	onChangeCuit = ({ target: { value } }) => {
		let error = this.state.cuitRequerido;
		if (_.trim(value)) {
			error = "";
		}
		this.setState({
			cuit: value,
			cuitRequerido: error
		});
	};

	renderBodyRows = declaracionJuradasList => {
		const Show = this.handleShow;
		const Delete = this.handleDelete;
		return _.map(declaracionJuradasList, (item, i) => {
			let declaracionJurada = item;
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
					<TableRowColumn>{declaracionJurada.company.name}</TableRowColumn>
					<TableRowColumn style={{ width: "8%" }}>
						{declaracionJurada.number}
					</TableRowColumn>
					<TableRowColumn style={{ width: "3%" }}>
						{declaracionJurada.month}
					</TableRowColumn>
					<TableRowColumn style={{ width: "5%" }}>
						{declaracionJurada.year}
					</TableRowColumn>
					<TableRowColumn style={{ width: "5%" }}>
						{declaracionJurada.version}
					</TableRowColumn>
					<TableRowColumn
						style={
							declaracionJurada.status === ESTADO_DDJJ_ANULADA
								? {
										width: "8%",
										color: "red"
									}
								: declaracionJurada.status === ESTADO_DDJJ_ACTIVA
									? {
											width: "8%",
											color: "green"
										}
									: { width: "8%" }
						}
					>
						{declaracionJurada.status}
					</TableRowColumn>
					<TableRowColumn style={{ width: "8%" }}>
						{Util.formatDateToShowNotHour(declaracionJurada.expiredDate)}
					</TableRowColumn>
					<TableRowColumn style={{ width: "10%" }}>
						{`$ ${Util.formatDouble(declaracionJurada.contributionTotal)}`}
					</TableRowColumn>
					<TableRowColumn
						style={
							declaracionJurada.paidStatus === ESTADO_TICKET_ANULADO ||
							declaracionJurada.paidStatus === ESTADO_TICKET_VENCIDO
								? {
										width: "10%",
										color: "red"
									}
								: declaracionJurada.paidStatus === ESTADO_TICKET_PAGADO
									? {
											width: "10%",
											color: "green"
										}
									: declaracionJurada.paidStatus ===
											ESTADO_TICKET_PENDIENTE_PAGO ||
										declaracionJurada.paidStatus === ESTADO_TICKET_PAGO_PARCIAL
										? {
												width: "10%",
												color: "blue"
											}
										: {
												width: "10%",
												color: "black"
											}
						}
					>
						{declaracionJurada.paidStatus == null
							? ""
							: declaracionJurada.paidStatus}
					</TableRowColumn>
					<TableRowColumn style={{ width: "10%" }}>
						<OptionsTableRowColumn
							handleShow={
								declaracionJurada.status !== ESTADO_DDJJ_ANULADA
									? () => Show(declaracionJurada)
									: null
							}
							handleDelete={
								declaracionJurada.status !== ESTADO_DDJJ_ANULADA
									? this.props.rol !== ROL_OPERADOR_AFFI &&
										this.props.rol !== ROL_OPERADOR_RECAUDA
										? () => Delete(declaracionJurada)
										: null
									: null
							}
							handleNote={
								declaracionJurada.status === ESTADO_DDJJ_ANULADA
									? () => Show(declaracionJurada)
									: null
							}
							showNoty={declaracionJurada.notes}
							showTooltip="Ver"
						/>
					</TableRowColumn>
				</TableRow>
			);
		});
	};
	renderMeses() {
		let months = [];
		_.map(MESES, (mes, i) => {
			months.push(<MenuItem value={i + 1} key={i + 1} primaryText={mes} />);
		});
		return months;
	}
	onChangeMes = (event, index, value) => {
		this.props.actionChangeDeclaracionJuradaProps({
			mes: value
		});
	};

	onChangeAnio = (event, index, value) => {
		this.props.actionChangeDeclaracionJuradaProps({
			anio: value
		});
	};

	onChangeStatus = (event, index, value) => {
		this.props.actionChangeDeclaracionJuradaProps({
			status: value
		});
	};
	toggledFilterButton() {
		if (this.state.showFilterCard) {
			this.props.actionChangeDeclaracionJuradaProps({
				mes: null,
				anio: null,
				status: null,
				activeFilters: false,
				declaracionJuradasList: [],
				searchtext: ""
			});
			this.setState({
				showFilterCard: !this.state.showFilterCard
			});
		} else {
			this.setState({
				showFilterCard: !this.state.showFilterCard
			});
		}
	}
	onChangeRadioButtonGroup(event, value) {
		if (value === "all") {
			this.setState({
				disabledPeriodFilter: !this.state.disabledPeriodFilter,
				all: true,
				period: false,
				company: false
			});
		}
		if (value === "period") {
			this.setState({
				disabledPeriodFilter: !this.state.disabledPeriodFilter,
				all: false,
				period: true,
				company: false
			});
		}
		if (value === "company") {
			this.setState({
				disabledCompanyFilter: !this.state.disabledCompanyFilter,
				all: false,
				period: false,
				company: true
			});
		}
	}
	onChangeDateField(name, value) {
		if (name === "date_from") {
			this.setState({
				date_from: value
			});
		} else if (name === "date_to") {
			this.setState({
				date_to: value
			});
		}
	}
	generateExcelFilterShow(type) {
		this.refs["generateExcelFilter"].open({
			title: "Generar Excel de Declaraciones Juradas",
			onAccept: this.onTapConfirmGenerateExcel.bind(this, type),
			requiredValidation: true
		});
	}
	onTapConfirmGenerateExcel(type) {
		let dateFrom = moment(this.state.date_from).format("YYYY-MM-DD");
		let dateTo = moment(this.state.date_to).format("YYYY-MM-DD");
		if (this.state.all) {
			//todos los periodos
			this.props.actionGenerateExcel(type, null, null, this.returnDownload);
		} else if (this.state.period) {
			//DDJJ filtradas
			this.props.actionGenerateExcel(
				type,
				dateFrom,
				dateTo,
				this.returnDownload
			);
		} else if (this.state.company && this.props.empresa) {
			this.props.actionGenerateExcelById(
				"ddjjCompany",
				this.props.empresa.id,
				this.returnDownload
			);
		} else if (this.state.company && !this.props.empresa) {
			this.setState({
				cuitRequerido: "Debe ingresar y buscar una empresa."
			});
			return;
		}
		this.refs["generateExcelFilter"].close();
		this.setState({
			date_from: new Date(),
			date_to: new Date(),
			disabledPeriodFilter: true,
			disabledCompanyFilter: true,
			cuit: "",
			period: false,
			all: false,
			company: false
		});
	}
	onClickSearchCuit = () => {
		let cuit = Util.formatCuitToNumber(this.state.cuit);
		this.props.actionGetEmpresaByCuit(cuit);
	};
	renderFilterCardByRol() {
		return (
			<div>
				{" "}
				{this.props.rol === ROL_ADMIN || this.props.rol === ROL_SUB_ADMIN ? (
					<FilterCard
						onChangeSearchField={this.onChangeSearch}
						InputValue={this.props.searchtext}
						onKeyPressSearchField={this.handleKeyPressSearchInput}
						onTouchTapSearch={() => this.handleSearch(this.props.searchtext)}
						onToggledFilter={this.toggledFilterButton}
						activeFilters={this.props.activeFilters}
						labelSearchInput={"Buscar Nombre o Cuit"}
						onTouchGenerateExcel={() => this.generateExcelFilterShow("ddjj")}
						generateExcelLabel={"Generar Excel DDJJ"}
						onTouchDownloadExcelExample={() => this.onDownloadDDJJ()}
						downloadExcelExampleLabel={"Descargar formato DDJJ excel ejemplo"}
					/>
				) : this.props.rol === ROL_EMPRESA ? (
					<FilterCard
						onToggledFilter={this.toggledFilterButton}
						activeFilters={this.props.activeFilters}
						onTouchDownloadExcelExample={() => this.onDownloadDDJJ()}
						downloadExcelExampleLabel={"Descargar formato DDJJ excel ejemplo"}
						onTouchNewDDJJ={() => this.onCreateOrUpdate()}
						newDDJJLabel={"Nueva DJ"}
					/>
				) : (
					<FilterCard
						onChangeSearchField={this.onChangeSearch}
						InputValue={this.props.searchtext}
						onKeyPressSearchField={this.handleKeyPressSearchInput}
						onTouchTapSearch={() => this.handleSearch(this.props.searchtext)}
						onToggledFilter={this.toggledFilterButton}
						activeFilters={this.props.activeFilters}
						labelSearchInput={"Buscar Nombre o Cuit"}
						onTouchDownloadExcelExample={() => this.onDownloadDDJJ()}
						downloadExcelExampleLabel={"Descargar formato DDJJ excel ejemplo"}
					/>
				)}
			</div>
		);
	}
	render() {
		return (
			<div>
				<Card>
					<CardTitle
						title="Declaraciones Juradas"
						subtitle="Listado de declaraciones juradas"
					/>
					<CardText>
						{this.renderFilterCardByRol()}
						<ReactCSSTransitionGroup
							transitionName="animate"
							transitionAppear={true}
							transitionAppearTimeout={5000}
							transitionEnter={true}
							transitionEnterTimeout={500}
							transitionLeaveTimeout={500}
							transitionLeave={true}
						>
							{!this.state.showFilterCard ? null : (
								<CardMedia>
									<div className="card-filter top20">
										<div className="align-center rows-column-simple">
											<div className="columns-row-between columns-half">
												<SelectField
													floatingLabelText="Mes"
													value={this.props.mes}
													onChange={this.onChangeMes}
												>
													{this.renderMeses()}
												</SelectField>
												<SelectField
													floatingLabelText="Año"
													value={this.props.anio}
													onChange={this.onChangeAnio}
												>
													{this.state.anios}
												</SelectField>
												<SelectField
													floatingLabelText="Estado"
													value={this.props.status}
													onChange={this.onChangeStatus}
												>
													<MenuItem
														value={ESTADO_DDJJ_ANULADA}
														key={0}
														primaryText={ESTADO_DDJJ_ANULADA}
													/>
													<MenuItem
														value={ESTADO_DDJJ_ACTIVA}
														key={1}
														primaryText={ESTADO_DDJJ_ACTIVA}
													/>
												</SelectField>
											</div>
											<div style={{ padding: 10, marginTop: 10 }}>
												<FlatButton
													label="Quitar Filtros"
													onClick={this.CleanFilters}
												/>
												<RaisedButton
													label="Aplicar Filtros"
													primary={true}
													onClick={this.handleSearch}
												/>
											</div>
										</div>
									</div>
								</CardMedia>
							)}
						</ReactCSSTransitionGroup>
						<div className="top10">
							<Table selectable={false}>
								<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
									<TableRow>
										<TableHeaderColumn>Empresa</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "8%" }}>
											DDJJ Número
										</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "3%" }}>
											Mes
										</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "5%" }}>
											Año
										</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "5%" }}>
											Versión
										</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "8%" }}>
											Estado
										</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "8%" }}>
											Vencimiento
										</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "10%" }}>
											Importe
										</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "10%" }}>
											Pagado
										</TableHeaderColumn>
										<TableHeaderColumn style={{ width: "10%" }}>
											Acciones
										</TableHeaderColumn>
									</TableRow>
								</TableHeader>
								<TableBody
									deselectOnClickaway={false}
									displayRowCheckbox={false}
								>
									{!_.isEmpty(this.props.declaracionJuradasList)
										? this.renderBodyRows(this.props.declaracionJuradasList)
										: this.renderBlank()}
								</TableBody>
							</Table>
						</div>
					</CardText>
					{!_.isEmpty(this.props.declaracionJuradasList)
						? this.renderPaginator()
						: ""}
				</Card>
				<ConfirmDialog ref="deleteConfirm">
					<div>
						<h3>Para anular una Declaración Jurada debe ingresar un motivo.</h3>
						<TextField
							hintText="Ingrese motivo de anulación"
							floatingLabelText="Ingrese motivo de anulación"
							fullWidth={true}
							errorText={this.state.comentarioDeleteRequerido}
							value={this.state.comentarioDelete}
							onChange={this.onChangeComentario}
						/>
					</div>
				</ConfirmDialog>
				<ConfirmDialog ref="generateExcelFilter">
					<div className="columns-row-around card-filter paddingTop20">
						<div className="columns-column-between">
							<RadioButtonGroup
								name="filterDDJJ"
								defaultSelected="all"
								onChange={this.onChangeRadioButtonGroup}
							>
								<RadioButton
									value="all"
									label="Todas las declaraciones"
									style={{ marginBottom: 16 }}
								/>
								<RadioButton
									value="period"
									label="Filtrar por Periodo"
									style={{ marginBottom: 16, marginTop: 20 }}
								/>
								<RadioButton
									value="company"
									label="Filtrar por Empresa"
									style={{ marginBottom: 16, marginTop: 50 }}
								/>
							</RadioButtonGroup>
						</div>
						<div className="columns-column-between top20">
							<DateRange
								ref="date"
								labelOne="Periodo Desde"
								labelTwo="Periodo Hasta"
								dateFromField="date_from"
								dateToField="date_to"
								dateFrom={this.state.date_from}
								dateTo={this.state.date_to}
								errorDateTo={this.state.errors.date_from}
								errorDateFrom={this.state.errors.date_to}
								onChangeDateField={this.onChangeDateField}
								disabledDate={this.state.disabledPeriodFilter}
							/>
							<div className="columns-row-between" style={{ marginTop: -15 }}>
								<MaskedTextField
									name="cuitCompany"
									floatingLabelText="CUIT"
									style={{ marginLeft: 20 }}
									disabled={this.state.disabledCompanyFilter ? true : false}
									onChange={this.onChangeCuit}
									errorText={this.state.cuitRequerido}
									value={this.state.cuit}
									mask={[
										/\d/,
										/\d/,
										"-",
										/\d/,
										/\d/,
										/\d/,
										/\d/,
										/\d/,
										/\d/,
										/\d/,
										/\d/,
										"-",
										/\d/
									]}
								/>
								<FloatingActionButton
									onClick={this.onClickSearchCuit}
									style={{ marginTop: 20 }}
									zDepth={0}
									disabled={this.state.disabledCompanyFilter ? true : false}
								>
									<SearchIcon />
								</FloatingActionButton>
							</div>
							<div
								style={{
									color: "red",
									paddingLeft: 20,
									paddingTop: 25
								}}
							>
								{" "}
								{this.state.cuitRequerido}{" "}
							</div>
							<div
								className="columns-row-between"
								style={{ marginLeft: 20, marginBottom: 20 }}
							>
								<TextField
									style={{ minWidth: "50%" }}
									floatingLabelText="Empresa"
									value={this.props.empresa ? this.props.empresa.name : ""}
									disabled
								/>
							</div>
						</div>
					</div>
				</ConfirmDialog>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		mes: store.declaracionJurada.mes,
		anio: store.declaracionJurada.anio,
		status: store.declaracionJurada.status,
		searchtext: store.declaracionJurada.searchtext,
		declaracionJuradasList: store.declaracionJurada.declaracionJuradasList,
		busquedaRealizada: store.declaracionJurada.busquedaRealizada,
		activeFilters: store.declaracionJurada.activeFilters,
		modeCRU: store.declaracionJurada.modeCRU,
		page: store.declaracionJurada.page,
		rol: store.app.rol,
		total: store.declaracionJurada.total,
		empresa: store.empresa.empresa
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionChangeDeclaracionJuradaProps,
			actionGetDeclaracionJuradasList,
			actionUpdateDeclaracionJurada,
			actionDownloadFile,
			actionGenerateExcel,
			actionGetEmpresaByCuit,
			actionGenerateExcelById,
			actionChangeEmpresaProps
		},
		dispatch
	);
}

export default connect(mapStateToProps, mapDispatchToProps)(
	DeclaracionJuradasIndex
);



// WEBPACK FOOTER //
// ./src/screens/DeclaracionJurada/DeclaracionJuradaIndex.js